import React, { PureComponent } from 'react';
import Modal from 'react-modal';
import { find, isEmpty } from 'lodash';

import { createContainer } from '@dbk-legacy/muster/react';
import { FormattedMessage } from '@dbk/format';

import ListView from '../../../../../src/components/common/list-view';
import Text, { H3 } from '@dbk/ui-text';
import TouchableListItem from '../../../../../src/components/common/touchable-list-item';
import maskPortfolio from '../../../../../src/utils/mask-portfolio';
import { PALETTE } from '../../constants';

const MATURITY_7DAYS = 'maturities.7days';
const REPORTS = 'reports';

class NotificationModal extends PureComponent {
  constructor() {
    super();
    this.state = {
      modalIsOpen: true,
    };

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.handlePress = this.handlePress.bind(this);
    this.renderNotificationItemDetail = this.renderNotificationItemDetail.bind(this);
  }

  // componentDidMount() {
  //   this.openModal();
  // }
  // componentWillUnmount() {
  //   this.closeModal();
  // }

  openModal() {
    this.setState({ modalIsOpen: true });
  }
  afterOpenModal() {
    // references are now sync'd and can be accessed.
  }
  closeModal() {
    const { notifications: { markedAsRead }, auth: { isNotificationDisabledForRM } } = this.props;
    
    if(!isNotificationDisabledForRM){
      markedAsRead();
    }
    // this.setState({ modalIsOpen: false });
    this.props.onChange();
  }

  handlePress(type, detail) {
    const {
      changePage,
      rsaChangePage,
      rsa: { rsaAuthorised },
      app: {
        user: {
          selectedPortfolioId,
          portfoliosData,
          setSelectedPortfolioId,
          setSelectedPortfolioData,
        },
      },
      onDone,
    } = this.props;

    let pagename, isRoot;
    if (detail) {
      switch (type) {
        case MATURITY_7DAYS:
          pagename = '/maturities';
          isRoot = true;
          break;
        case REPORTS:
          pagename = '/reports';
          isRoot = true;
          break;
        default:
          break;
      }
      const portfolioData = find(portfoliosData, { id: detail.portfolioId });

      if (detail.portfolioId !== selectedPortfolioId && portfolioData != null) {
        setSelectedPortfolioId(detail.portfolioId);
        setSelectedPortfolioData(portfolioData);
      }
    }

    if (type === 'reports') {
      pagename = '/reports';
      isRoot = true;
      this.props.reports.setOpenDateRangeTab(true);
    }

    if (pagename != null) {
      this.closeModal();
      rsaChangePage(pagename, isRoot);
    }
  }

  renderNotificationItemDetail(item, detail, description) {
    return (
      <TouchableListItem
        onClick={this.props.auth.isNotificationDisabledForRM ? '' : () => this.handlePress(item.type, detail)}
        key={`${item.type}-${detail.portfolioId}`}
        hideArrow
      >
        <div className="notificationDetails pointer" style={{ paddingTop: 10 }}>
          <Text style={{ color: PALETTE.primaryActive }} >{description}</Text>
        </div>
      </TouchableListItem>
    );
  }

  renderContent(row) {
    const { type, count } = row;
    const { rsa: { rsaAuthorised }, i18n: { messages } } = this.props;
    let title, description, detailComponent;

    switch (type) {
      case MATURITY_7DAYS:
        title = messages['app.profile.notification.maturity'];
        description =
          messages['app.notification.title'] +
          ' ' +
          count +
          ' ' +
          messages['app.notification.upcomingMat'];
        detailComponent = row.details.map((dtl) =>
          this.renderNotificationItemDetail(
            row,
            dtl,
            <FormattedMessage
              id={`app.notifications.items.details.maturityDescription`}
              values={{
                n: dtl.count,
                portfolioTitle: dtl.portfolioTitle,
              }}
            />
          )
        );
        break;

      case REPORTS:
        title = messages['app.profile.notification.Statement'];
        description =
          messages['app.notification.title'] +
          ' ' +
          count +
          ' ' +
          messages['app.notification.reportCount'];

        detailComponent = row.detailsch.map((categoryItem) =>

          this.renderNotificationItemDetail(
            row,
            categoryItem,
            <FormattedMessage
              id={`app.notifications.items.details.reportDescription`}
              values={{
                count: categoryItem.count,
                catName: categoryItem.catName
              }}
            />
          )
        );
        break;
    }

    if (title == null) return null;

    return (
      <div>
        <div className="notification-title">{title}</div>
        <div
          onClick={() => this.handlePress(type)}
          className={type === 'reports' ? 'pointer' : null}
          style={{ color: "#a7a8aa", paddingTop: 5 }}
        >
          {description}
        </div>
        <div>{detailComponent}</div>
      </div>
    );
  }

  render() {
    const {
      screen,
      notifications: { userNotifications },
      i18n: { messages },
      marque: { loginDissmiss },
    } = this.props;
    const rowMarkerStyle = { fill: 'transparent' };

    const { height, width } = screen;
    const customStyles = {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 11,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
      },
      content: {
        position: 'absolute',
        top: loginDissmiss ? '49px' : '90px',
        left: width > 570 ? 'auto' : 40,
        right: '55px',
        bottom: 'auto',
        padding: 0,
        border: 0,
        // WebkitOverflowScrolling    : 'touch',
        width: width > 640 ? '450px' : width - 80 + 'px',
        maxWidth: '450px',
        backgroundColor: 'transparent',
        overflow: 'visible',
      },
    };
    return (
      <Modal
        isOpen={this.state.modalIsOpen}
        onAfterOpen={this.afterOpenModal}
        onRequestClose={this.closeModal}
        style={customStyles}
        contentLabel="Modal"
        testID="blur-modal"
        ariaHideApp={false}
      >
        <div className="db-modal notificationModal">
          <div className="noti-modal">
            <div className="noti-modal-before" style={{ 'borderBottomColor' : PALETTE.dbModalBackground}}/>
            {userNotifications === null || userNotifications === undefined ||
              isEmpty(userNotifications.notifications) ||
              userNotifications.total === 0 ? (
                <div className="text-center margin-top-15">
                  <H3>{messages['app.notification.noNotification']}</H3>
                </div>
              ) : (
                <ListView
                  rows={userNotifications.notifications}
                  testID="list"
                  renderRow={(row) => (
                    <ListView.Row key={row.key} markerStyle={rowMarkerStyle}>
                      {this.renderContent(row)}
                    </ListView.Row>
                  )}
                />
              )}
          </div>
        </div>
      </Modal>
    );
  }
}

export default createContainer({
  $queries: {
    screen: {
      height: true,
      width: true,
      isSmall: true,
    },
    notifications: {
      userNotifications: true,
      markedAsRead: { $call: 'markedAsRead' },
    },
    i18n: {
      messages: true,
    },
    changePage: { $call: 'ui.history.push' },
    rsaChangePage: { $call: 'rsa.changePage' },
    rsa: { rsaAuthorised: true },
    reports: {
      setOpenDateRangeTab: {
        $set: 'openDateRangeTab',
      },
    },
    auth: {
      isNotificationDisabledForRM: true
    },
    app: {
      user: {
        selectedPortfolioId: true,
        portfoliosData: true,
        setSelectedPortfolioId: {
          $set: 'selectedPortfolioId',
        },
        setSelectedPortfolioData: {
          $set: 'selectedPortfolioData',
        },
      },
    },
    marque: {
      loginDissmiss: true,
    },
  },
})(NotificationModal);
